import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  andWhere,
  buildQuery,
  FilterFn,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
  andAllWhere,
  noop,
} from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { HttpClient } from '@angular/common/http';
import { IPagination, IPaginationResult, IRequestResult } from '../../../../common/interfaces';
import { ICreateSocialMediaType } from './interfaces/create-social-media-type.interface';
import { IUpdateSocialMediaType } from './interfaces/update-social-media-type.interface';
import { environment as env } from '../../../../../environments/environment.prod';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { AbstractService } from '../../../../services/abstract.service';
import SocialMediaTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/masters/social-media-type/social-media-type.entity';
import { isNumber } from 'lodash';

const apiUrl = env.API_COMMON_URL;
const moduleName = 'social_media_type';

@Injectable({
  providedIn: 'root',
})
export class SocialMediaTypeService extends AbstractService<
  SocialMediaTypeAttributes,
  ICreateSocialMediaType,
  IUpdateSocialMediaType
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<SocialMediaTypeAttributes> & { status?: number[] }
  ): Observable<IPaginationResult<SocialMediaTypeAttributes>> {

    const statusesIds = options?.status ? options?.status.filter(status => isNumber(status)) : [];

    let queryConditions: FilterFn<SocialMediaTypeAttributes>[] = [
      where('_deleted', Ops.eq(false)),
      andWhere('logo', Ops.like(options.search ?? '', 'i')),
      orWhere('name', Ops.like(options.search ?? '', 'i')),
      statusesIds.length > 0 ? andAllWhere("statusId", Ops.in(...statusesIds)) : noop(),
    ];


    const query = buildQuery<SocialMediaTypeAttributes>(
      ...queryConditions,
      orderBy(
        options.sort ?? 'name',
        options.sortDirection == 'ASC' ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl + `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<SocialMediaTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<SocialMediaTypeAttributes[]>> {
    const query = buildQuery<SocialMediaTypeAttributes>(
      where('statusId', StatusEnum.ACTIVE),
      select(['name', 'logo']),
      orderBy('name', OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl + `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<SocialMediaTypeAttributes[]>>(API_URL);
  }
}
